import React, { useEffect, useRef, useState } from 'react';
import Draggable from 'react-draggable';
import { ResizableBox } from 'react-resizable';
import { Box, ButtonGroup, Flex, IconButton } from '@chakra-ui/react';
import { MdMinimize } from 'react-icons/md';
import { CgClose, CgMaximize } from 'react-icons/cg';

export const Window = (props) => {
  const DraggableRef = useRef(Draggable);

  const { redux } = props;
  let { windowStack } = redux.ui;

  const [loaded, setLoaded] = useState(false);

  let position = redux.ui.windows.find((item) => item.id === props.id).position;

  let donePosition = {
    x: position.length !== 0 ? position[0] : props.x,
    y: position.length !== 0 ? position[1] : props.y,
  };

  useEffect(() => {
    console.log('useEffect:', windowStack);
    setLoaded(true);
  }, [loaded, windowStack]);

  return (
    // TODO: this ain't it chief
    loaded && (
      <Box
        zIndex={100 + windowStack.indexOf(props.id)}
        pos={'relative'}
        onClick={() => {
          redux.setActiveWindowAction(props.id);
          redux.updateWindowsAction(redux.ui.windows);
          redux.updateWindowStackAction(props.id);
        }}
      >
        <Draggable
          handle={'.window-header'}
          ref={DraggableRef}
          defaultPosition={donePosition}
          onStart={() => {
            redux.setActiveWindowAction(props.id);
            redux.updateWindowStackAction(props.id);
          }}
          onStop={() => {
            redux.setWindowPositionAction(props.id, [
              DraggableRef.current.state.x,
              DraggableRef.current.state.y,
            ]);
          }}
        >
          <Box>
            <ResizableBox
              height={props.h ? props.h + 30 : 100}
              width={props.w ? props.w : 200}
              minConstraints={[
                props.minW ? props.minW : 200,
                props.minH ? props.minH + 30 : 100,
              ]}
              maxConstraints={[
                props.maxW ? props.maxW : Infinity,
                props.maxH ? props.maxH + 30 : Infinity,
              ]}
              lockAspectRatio={
                props.lockAspectRatio ? props.lockAspectRatio : false
              }
              resizeHandles={props.resizable ? ['se'] : []}
            >
              <Box
                pos="absolute"
                border={'1px solid black'}
                w={'100%'}
                h={'100%'}
                bg={'white'}
                boxSizing={'border-box'}
              >
                <Box
                  pos="absolute"
                  bg={'red.600'}
                  pl={2}
                  color={'red.100'}
                  w={'100%'}
                  className={'window-header'}
                  fontFamily={"'Glass TTY VT220', monospace"}
                  cursor={'grab'}
                  zIndex={1}
                  textTransform={'uppercase'}
                  fontSize={24}
                >
                  {props.header}
                  <Flex float={'right'} flexDir={'row'} minH={30}>
                    <ButtonGroup size={'sm'} isAttached color={'red.200'}>
                      <IconButton
                        bg={'transparent'}
                        _hover={{ bg: 'transparent', color: 'white' }}
                        _focus={{ bg: 'transparent', color: 'white' }}
                      >
                        <MdMinimize />
                      </IconButton>
                      <IconButton
                        bg={'transparent'}
                        _hover={{ bg: 'transparent', color: 'white' }}
                        _focus={{ bg: 'transparent', color: 'white' }}
                      >
                        <CgMaximize />
                      </IconButton>
                      <IconButton
                        bg={'transparent'}
                        _hover={{ bg: 'transparent', color: 'white' }}
                        _focus={{ bg: 'transparent', color: 'white' }}
                      >
                        <CgClose />
                      </IconButton>
                    </ButtonGroup>
                  </Flex>
                </Box>
                <Box w={'100%'} h={'100%'} overflowY={'auto'} pt={'30px'}>
                  {props.children}
                </Box>
              </Box>
            </ResizableBox>
          </Box>
        </Draggable>
      </Box>
    )
  );
};

export default Window;
